import Vue from 'vue'

export default {
  namespaced: true,

  state: {
    productList: [],
    dataSourceList: []
  },

  actions: {
    /** Fetch products by category */
    getProductByCategoryId({ commit, state }, ids) {
      state.productList = []

      Vue.prototype.$http.post('/product', ids).then((response) => {
        if (response.data.status === 200) {

          if (response.data && response.data.data) {
            const incoming = response.data.data;
            const newList = [];

            if (incoming.length) {
              for (const product of incoming) {
                const checkProduct = state.productList.filter(p => p.id === product.id);

                if (checkProduct.length) {
                  newList.push(product);
                }
              }
              commit('PRODUCTS', incoming);
            } else {
              commit('PRODUCTS', incoming);
            }
          }
        }
      });
    },

    /** This method returns all the sources for a particular category.  */
    getSourceByCategoryId({ commit, state }, ids) {
      state.dataSourceList = []
      Vue.prototype.$http.post('/source', ids).then((response) => {
        if (response.data.status === 200) {
          commit('DATA_SOURCE', response.data.data)
        }
      })
    },

    /** To Ask a question to Chatbot */
    askQuetionToChatbot({ commit, dispatch }, payload) {

      return Vue.prototype.$http.post('/voc/ask', payload)
        .then(response => {
          if (response.data && response.data.status === 200) {
            dispatch('client/getVocAiUsage', null, { root: true })
          }
          return response.data;        // return backend data to component
        })
        .catch(err => {
          throw err;
        });
    },

    async streamQuestionToChatbot({ commit, dispatch }, { payload, onChunk, onDone, onError }) {
      const baseURL = Vue.prototype.$http.defaults.baseURL || ''
      const makeRequest = async () => {
        return fetch(`${baseURL}/voc/ask`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: window.localStorage.getItem('access-token') || ''
          },
          body: JSON.stringify({
            ...payload,
            stream: true
          })
        })
      }

      const refreshAccessToken = async () => {
        const refreshToken = window.localStorage.getItem('refresh-token')

        if (!refreshToken) {
          throw new Error('No refresh token available')
        }

        const tokenResponse = await Vue.prototype.$http.post('/token', {
          token: refreshToken
        })

        window.localStorage.setItem(
          'access-token',
          'Bearer ' + tokenResponse.data.token
        )
        window.localStorage.setItem(
          'refresh-token',
          tokenResponse.data.refreshToken
        )
      }

      let response = await makeRequest()

      if (response.status === 401) {
        let errorPayload = {}

        try {
          errorPayload = await response.json()
        } catch (err) {
          errorPayload = {}
        }

        if (errorPayload?.info === 'token expired') {
          await refreshAccessToken()
          response = await makeRequest()
        }
      }

      if (!response.ok || !response.body) {
        const message = `Streaming request failed with status ${response.status}`
        if (typeof onError === 'function') {
          onError(new Error(message))
        }
        throw new Error(message)
      }

      const reader = response.body.getReader()
      const decoder = new TextDecoder()
      let buffer = ''
      let finalPayload = null

      const processEventBlock = (block) => {
        const lines = block.split('\n')
        let eventName = 'message'
        const dataLines = []

        lines.forEach((line) => {
          if (line.startsWith('event:')) {
            eventName = line.slice(6).trim()
          } else if (line.startsWith('data:')) {
            dataLines.push(line.slice(5).trim())
          }
        })

        if (!dataLines.length) {
          return
        }

        const eventPayload = JSON.parse(dataLines.join('\n'))

        if (eventName === 'chunk' && typeof onChunk === 'function') {
          onChunk(eventPayload)
        }

        if (eventName === 'done') {
          finalPayload = eventPayload
          if (typeof onDone === 'function') {
            onDone(eventPayload)
          }
        }

        if (eventName === 'error') {
          const error = new Error(eventPayload.message || 'Streaming request failed')
          if (typeof onError === 'function') {
            onError(error)
          }
          throw error
        }
      }

      while (true) {
        const { done, value } = await reader.read()
        buffer += decoder.decode(value || new Uint8Array(), { stream: !done })

        const blocks = buffer.split('\n\n')
        buffer = blocks.pop() || ''

        blocks.forEach(processEventBlock)

        if (done) {
          break
        }
      }

      if (buffer.trim()) {
        processEventBlock(buffer)
      }

      if (finalPayload) {
        dispatch('client/getVocAiUsage', null, { root: true })
      }

      return finalPayload
    },

    /** Fetch AI Chatbot Chat History */
    getAIChatbotChatHistory({ commit }, {session_id, user_id}) {
      return Vue.prototype.$http.get(`/voc/history?session_id=${session_id}&user_id=${user_id}`)
        .then((response) => {
          if (response.data.status === 200) {
            return response?.data?.data?.conversation_history
          }
        })
        .catch((error) => {
          throw error
        });
    },

    /** get AI Chatbot Export Chat History JSON */
    getAIChatExport({ commit }, {session_id, user_id}) {

      return Vue.prototype.$http.get(`/voc/chat/export?session_id=${session_id}&user_id=${user_id}`)
        .then((response) => {
          if (response.data.status === 200) {
            return response.data
          }
        })
        .catch((error) => {
          throw error
        });
    },

    /** Deletes AI Chatbot Chat Session */
    deleteAIChatSession({ commit }, user_id) {

      return Vue.prototype.$http.delete(`/voc/session/${user_id}`)
        .then((response) => {
          if (response.data.status === 200) {
            return response.data
          }
        })
        .catch((error) => {
          throw error
        });
    },


  },

  mutations: {
    PRODUCTS(state, products) {
      state.productList = products;
    },
    DATA_SOURCE(state, payload) {
      state.dataSourceList = payload
    },
  },
}
